import { useState } from 'react';
import { LoginForm } from '../components/LoginForm';
import peptalkLogo from '../assets/peptalk-logo-white.svg';

export const AuthPanel = () => {
  const [errorMessage, setErrorMessage] = useState('');

  const handleError = ({ isError, message }) => {
    if (isError) return setErrorMessage(message);
    setErrorMessage('');
  };

  return (
    <div
      style={{
        width: 300,
        maxWidth: '100%',
        margin: '0 auto',
        marginTop: 150,
        padding: 10,
        boxSizing: 'border-box',
      }}
    >
      <img
        src={peptalkLogo}
        alt="peptalk logo"
        style={{ width: '65%', display: 'flex', margin: '0 auto' }}
      />
      <h2 style={{ textAlign: 'center', lineHeight: 1.3 }}>
        Please login to access <b style={{ color: 'darkgrey' }}>PepTalk</b>
      </h2>
      <LoginForm onError={handleError} isError={!!errorMessage} />
      {errorMessage && (
        <div>
          <h3 style={{ color: 'red', textAlign: 'center' }}>
            Error: {errorMessage}
          </h3>
        </div>
      )}
    </div>
  );
};

export default AuthPanel;
